import React from 'react';
import UniversalAddItemForm from '../shared/UniversalAddItemForm';

const AddItemToCorrectionStockForm = ({ refCorrection, onSuccess }) => {
  return (
    <UniversalAddItemForm
      refField="REF_COR"
      refValue={refCorrection}
      onSuccess={onSuccess}
      priceType="none"
      enableBatch={true}
      useArticleList={false}
      extraFields={{ REMARQUE: '' }}
      submitButtonText="Add all to Correction Stock"
    />
  );
};

export default AddItemToCorrectionStockForm;
